module.exports = __webpack_public_path__ + "img/folder-open-dont.7f26a55a.svg";